import { useState, useEffect } from 'react';
import { DeclarationDocumentsTableContent } from './DeclarationDocumentsTableContent';
import { getDeclarationSummaryTranslation } from '../../../hooks/useLanguage';

export const DeclarationDocumentsTable = ({
  declarationIndex,
  isSpanish,
  declaration,
  editableData,
  setEditableData,
  setIsDirty,
}) => {
  const [openDocModalIndex, setOpenDocModalIndex] = useState(null);
  const [openTipoModal, setOpenTipoModal] = useState({});

  // Automatically aggregate documentos from partidas if declaration.documentos is empty
  useEffect(() => {
    if (!declaration || !declaration.partidas) return;
    
    // Only auto-populate if documentos array doesn't exist or is empty
    if (!declaration.documentos || !Array.isArray(declaration.documentos) || declaration.documentos.length === 0) {
      const allDocumentos = [];
      declaration.partidas.forEach((partida) => {
        if (partida.documentos && Array.isArray(partida.documentos)) {
          partida.documentos.forEach((doc) => {
            if (doc && typeof doc === 'object') {
              allDocumentos.push({ ...doc }); // Deep copy
            }
          });
        }
      });
      
      // Only update if we found documentos
      if (allDocumentos.length > 0) {
        const updatedData = JSON.parse(JSON.stringify(editableData));
        updatedData[declarationIndex].documentos = allDocumentos;
        setEditableData(updatedData);
        setIsDirty(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [declaration?.partidas]);

  // Get documentos to display (either from declaration or aggregated)
  const documentosToDisplay = declaration.documentos && Array.isArray(declaration.documentos) && declaration.documentos.length > 0
    ? declaration.documentos
    : (() => {
        if (!declaration.partidas) return [];
        const allDocumentos = [];
        declaration.partidas.forEach((partida) => {
          if (partida.documentos && Array.isArray(partida.documentos)) {
            partida.documentos.forEach((doc) => {
              if (doc && typeof doc === 'object') {
                allDocumentos.push({ ...doc });
              }
            });
          }
        });
        return allDocumentos;
      })();

  if (!documentosToDisplay || documentosToDisplay.length === 0) {
    return null;
  }

  return (
    <div className="document-table mt-6">
      <div className="form-group flex-1 mt-12 !mb-0 flex justify-between flex-row items-center">
        <label htmlFor="companyName" className="!mb-0 !text-sm !opacity-100 !text-xl font-semibold uppercase">
          {!isSpanish ? "Export Level Documents" : "Documentos Nivel Exportación"} (
          {documentosToDisplay.length})
        </label>
      </div>
      <DeclarationDocumentsTableContent
        declarationIndex={declarationIndex}
        isSpanish={isSpanish}
        declaration={{ ...declaration, documentos: documentosToDisplay }}
        editableData={editableData}
        setEditableData={setEditableData}
        setIsDirty={setIsDirty}
        openDocModalIndex={openDocModalIndex}
        setOpenDocModalIndex={setOpenDocModalIndex}
        openTipoModal={openTipoModal}
        setOpenTipoModal={setOpenTipoModal}
      />
    </div>
  );
};

